
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';


// Move to own class file
export class ProjectActivityStatus {
	type: string;
	date: Date;
	ready: boolean;
}

// TODO
export function getActivityDateAndReady(project: Project, activityType: string): ProjectActivityStatus{
	const activityStatus = new ProjectActivityStatus();
	activityStatus.type = activityType;

	if ((project as any).hasOwnProperty(activityType + 'Date')) {
		if (project[activityType + 'Date']) {
			activityStatus.date = new Date(project[activityType + 'Date'].getTime());
		}
	}
	else {
		console.error(`Field ${activityType}Date not found`)
	}

	if ((project as any).hasOwnProperty(activityType + 'Date')) {
		if (project[activityType + 'Date']) {
			activityStatus.ready = project[activityType + 'Ready']
		}
	}
	else {
		console.error(`Field ${activityType}Ready not found`)
	}
	return activityStatus;
}
